<script lang="ts">
	import {
		AdvancedCard,
		ActionsContainer,
		IconButton,
		LabelList,
		DaySchedule,
	} from '@Shelly/shelly-design-system';
	import type { ActionsContainerProps } from '@Shelly/shelly-design-system/ActionsContainer/ActionsContainer.svelte';
	import { startsWeekOnSun } from 'src/helpers/date_helper';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	const dispatch = createEventDispatcher();
	let className = '';
	export { className as class };
	export let element: any = {};
	export let title: string = 'UNDEFINED VAL',
		avatar: any = { icon: 'far fa-termometer' },
		subtitle: {} = { value: 'Condition Description', bold: false },
		description: {} = { value: 'Additional info', icon: 'fas fa-clock' },
		labelList = [],
		withLabelList = false,
		withSchedule = false,
		days = [],
		disableDelete = false,
		orientation: ActionsContainerProps['orientation'] = 'vertical';

	let isFocusable = false;
	if (startsWeekOnSun()) {
		days.unshift(days.pop());
	}
</script>

{#if withLabelList}
	<AdvancedCard aria-label={title} class={className} {avatar} {title} {isFocusable}>
		<LabelList {labelList} slot="main" size="m" />
		<ActionsContainer {orientation} type="simple" slot="right">
			<IconButton
				aria-label={$format('input_edit', { default: 'Edit' })}
				icon="fas fa-pen"
				slot="first"
				on:click={(e) => {
					e.stopPropagation();
					dispatch('edit');
				}}
			/>
			<IconButton
				aria-label={$format('button_delete', { default: 'Delete' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={(e) => {
					e.stopPropagation();
					dispatch('delete');
				}}
			/>
		</ActionsContainer>
	</AdvancedCard>
{:else if withSchedule}
	<AdvancedCard
		aria-label={title}
		{title}
		{avatar}
		{subtitle}
		{description}
		{isFocusable}
		on:click={(e) => dispatch('open_detailed')}
	>
		<DaySchedule {days} slot="title" />

		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				aria-label={$format('input_edit', { default: 'Edit' })}
				icon="fas fa-pen"
				slot="first"
				on:click={() => dispatch('edit')}
			/>
			<!-- {#if withDeleteBtn} -->
			<IconButton
				aria-label={$format('button_delete', { default: 'Delete' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				disabled={disableDelete}
				on:click={(e) => {
					e.stopPropagation();
					dispatch('delete');
				}}
			/>
			<!-- {/if} -->
		</ActionsContainer>
	</AdvancedCard>
{:else}
	<AdvancedCard
		aria-label={title}
		{avatar}
		{title}
		{subtitle}
		{description}
		{isFocusable}
		on:click={(e) => dispatch('open_detailed')}
	>
		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				aria-label={$format('input_edit', { default: 'Edit' })}
				disabled={element.hasOwnProperty('extra')}
				icon="fas fa-pen"
				slot="first"
				on:click={() => dispatch('edit')}
			/>
			<IconButton
				aria-label={$format('button_delete', { default: 'Delete' })}
				disabled={element.hasOwnProperty('extra')}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={() => dispatch('delete')}
			/>
		</ActionsContainer>
	</AdvancedCard>
{/if}
